import React from 'react';
import { ArrowLeft, Mail, Smartphone } from 'lucide-react';
import OtpInput from './OtpInput';

// Shared 2FA code-entry step used by every admin login (Ginox / Gidex / Support).
// Presentational only — the parent owns the verify call and state.
const TwoFactorStep = ({
  method,
  email,
  code,
  onCodeChange,
  onComplete,
  onVerify,
  onBack,
  loading = false,
  error,
}) => {
  const isEmail = method === 'email';
  return (
    <div className="space-y-5">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-ginox-green/20 bg-ginox-green/10">
          {isEmail ? (
            <Mail className="h-5 w-5 text-ginox-green" />
          ) : (
            <Smartphone className="h-5 w-5 text-ginox-green" />
          )}
        </div>
        <div>
          <h2 className="text-sm font-medium text-foreground">
            {isEmail ? 'Check your email' : 'Authenticator code'}
          </h2>
          <p className="mt-0.5 text-xs text-muted-foreground leading-relaxed">
            {isEmail
              ? `Enter the 6-digit code we sent to ${email}.`
              : 'Enter the 6-digit code from your authenticator app.'}
          </p>
        </div>
      </div>

      <div className="flex justify-center py-1">
        <OtpInput
          value={code}
          onChange={onCodeChange}
          onComplete={onComplete}
          autoFocus
          disabled={loading}
        />
      </div>

      {error && (
        <div className="rounded-md border border-red-500/30 bg-red-500/10 px-3 py-2 text-xs text-red-400">
          {error}
        </div>
      )}

      <button
        type="button"
        onClick={onVerify}
        disabled={loading || code.length !== 6}
        className="w-full rounded-md bg-ginox-green px-4 py-2.5 text-sm font-semibold text-black hover:bg-ginox-green/90 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        {loading ? (
          <span className="flex items-center justify-center gap-2">
            <span className="h-4 w-4 rounded-full border-2 border-black/30 border-t-black animate-spin" />
            Verifying...
          </span>
        ) : (
          'Verify'
        )}
      </button>

      <button
        type="button"
        onClick={onBack}
        disabled={loading}
        className="flex w-full items-center justify-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors disabled:opacity-50"
      >
        <ArrowLeft className="h-3.5 w-3.5" />
        Back to login
      </button>
    </div>
  );
};

export default TwoFactorStep;
